<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>{{ title }}</strong>
                    </div>
                    <b-form id="reportForm">
                        <b-row v-if="reportSync.syncSourceType">
                            <b-col offset-md="2">
                                <b-form-group label="Phần mềm đồng bộ:" v-if="listSyncSourceTypes.length > 0"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 no-padding">
                                        <select2 v-model="searchForm.syncSourceType" :options="listSyncSourceTypes" placeholder="--- Tất cả ---" multiple
                                                 :allowClear="true"></select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportSync.unitTree">
                            <b-col offset-md="2">
                                <b-form-group label="Đơn vị xuất báo cáo:"
                                              label-for="input-unit"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <input type="hidden" name="unitId" v-model="searchForm.unitId" />
                                    <template v-if="showUnitTree">
                                        <unit-tree :cached="true" ref="unitTree" v-model="searchForm.unitId" :syncSourceType="searchForm.syncSourceType[0]" class="no-padding col-6"></unit-tree>
                                    </template>
                                    <template v-else>
                                        <div class="no-padding col-6">
                                            <top-level-unit :cached="true" v-model="searchForm.unitId" allowClear="true"></top-level-unit>
                                        </div>
                                    </template>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportSync.unitLevel">
                            <b-col offset-md="2">
                                <b-form-group label="Bậc đơn vị:"
                                              label-for="input-startdate"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <input type="hidden" v-model="searchForm.unitLevel" name="unitLevel" />
                                        <select2 v-if="listReportUnitLevel.length > 0" :options="listReportUnitLevel"
                                                 v-model="searchForm.unitLevel"></select2>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn bậc đơn vị
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row v-if="reportSync.periodType == 1">
                            <b-col offset-md="2">
                                <b-form-group label="Ngày báo cáo:"
                                              label-for="input-reportdate"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <div class="col-6 no-padding">
                                        <input type="hidden" v-model="searchForm.reportDate" name="reportDate" />
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="reportDateFeedback"
                                                      v-model="$v.searchForm.reportDate.$model"
                                                      :state="$v.searchForm.reportDate.$dirty ? !$v.searchForm.reportDate.$error : null">
                                        </b-form-input>
                                        <date-picker v-model="searchForm.reportDate" placeholder="--- Chọn ---">
                                        </date-picker>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn ngày báo cáo
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <b-row v-if="reportSync.assetSource">
                            <b-col offset-md="2">
                                <b-form-group label="Nguồn gốc tài sản:"
                                              label-for="input-parentname"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 no-padding">
                                        <!--<treeselect v-if="assetSources.length > 0" :options="assetSources"
                                        v-model="searchForm.assetSourceId"
                                        :default-expand-level="1"
                                        placeholder="--- Tất cả ---"
                                        allowClear="true"></treeselect>-->
                                        <select2 v-if="assetSources.length > 0" :options="assetSources"
                                                 v-model="searchForm.assetSourceId" name="assetSourceId"
                                                 placeholder="--- Tất cả ---"
                                                 allowClear="true"
                                                 multiple
                                                 class="col-6 no-padding"> </select2>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn nguồn gốc tài sản
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportSync.assetTypeGroupId">
                            <b-col offset-md="2">
                                <b-form-group label="Loại tài sản:"
                                              label-for="input-quantity"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <!--<b-form-input type="text" style="display: none"
                                                      aria-describedby="reportDateFeedback"
                                                      v-model="$v.searchForm.assetTypeGroupId.$model"
                                                      :state="$v.searchForm.assetTypeGroupId.$dirty ? !$v.searchForm.assetTypeGroupId.$error : null">
                                        </b-form-input>-->
                                        <select2 v-if="assetTypeGroups.length > 0" :options="assetTypeGroups"
                                                 v-model="searchForm.assetTypeGroupId"
                                                 id="assetTypeGroupId" name="assetTypeGroupId"
                                                 placeholder="--- Tất cả ---"
                                                 multiple
                                                 allowClear="true"
                                                 class="col-6 no-padding"> </select2>
                                        <!--<b-form-invalid-feedback>
                                            Vui lòng chọn loại tài sản
                                        </b-form-invalid-feedback>-->
                                    </div>

                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportSync.assetTypeLevel">
                            <b-col offset-md="2">
                                <b-form-group label="Bậc loại tài sản:"
                                              label-for="input-startdate"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <input type="hidden" v-model="searchForm.assetTypeLevel" name="assetTypeLevel" />
                                        <select2 v-if="listReportAssetTypeLevel.length > 0" :options="listReportAssetTypeLevel"
                                                 v-model="searchForm.assetTypeLevel"></select2>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn bậc tài sản
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>


                        <b-row v-if="reportSync.periodType == 2 || reportSync.periodType == 1">
                            <b-col offset-md="2">
                                <b-form-group label="Số liệu báo cáo từ ngày:"
                                              label-for="input-startdate"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <input type="hidden" v-model="searchForm.reportStartDate" name="reportStartDate" />
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="reportDateFeedback"
                                                  v-model="$v.searchForm.reportStartDate.$model"
                                                  :state="$v.searchForm.reportStartDate.$dirty ? !$v.searchForm.reportStartDate.$error : null">
                                    </b-form-input>
                                    <date-picker id="input-startdate"
                                                 v-model="searchForm.reportStartDate"
                                                 class="col-6 no-padding"
                                                 placeholder="dd/mm/yyyy">
                                    </date-picker>
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn từ ngày
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportSync.periodType == 2 || reportSync.periodType == 1">
                            <b-col offset-md="2">
                                <b-form-group label="Đến ngày:"
                                              label-for="input-enddate"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <input type="hidden" v-model="searchForm.reportEndDate" name="reportEndDate" />
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="reportDateFeedback"
                                                  v-model="$v.searchForm.reportEndDate.$model"
                                                  :state="$v.searchForm.reportEndDate.$dirty ? !$v.searchForm.reportEndDate.$error : null">
                                    </b-form-input>
                                    <date-picker id="input-enddate"
                                                 v-model="searchForm.reportEndDate"
                                                 class="col-6 no-padding"
                                                 placeholder="dd/mm/yyyy">
                                    </date-picker>
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn đến ngày
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportSync.periodType == 3">
                            <b-col offset-md="2">
                                <b-form-group label="Năm báo cáo:"
                                              label-for="input-reportyear"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <input type="hidden" v-model="searchForm.reportYear" name="reportYear" />
                                    <b-form-input type="number" class="col-6" min="2000"
                                                  aria-describedby="reportDateFeedback"
                                                  v-model="$v.searchForm.reportYear.$model"
                                                  :state="$v.searchForm.reportYear.$dirty ? !$v.searchForm.reportYear.$error : null">
                                    </b-form-input>
                                    <!--<date-picker type="year" id="input-reportyear" format="YYYY" valueType="format"
                                                 v-model="$v.searchForm.reportYear.$model"
                                                 class="col-6 no-padding">
                                    </date-picker>-->
                                    <b-form-invalid-feedback>
                                        <span v-if="searchForm.reportYear== ''">Vui lòng chọn năm báo cáo</span>
                                        <span v-if="searchForm.reportYear < 0">Vui lòng nhập giá trị hợp lệ</span>
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Thời gian đồng bộ từ ngày:"
                                              label-for="input-startdate"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <input type="hidden" v-model="searchForm.syncStartDate" name="syncStartDate" />
                                    <date-picker id="input-startdate"
                                                 v-model="searchForm.syncStartDate"
                                                 class="col-6 no-padding"
                                                 placeholder="dd/mm/yyyy">
                                    </date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Đến ngày:"
                                              label-for="input-enddate"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <input type="hidden" v-model="searchForm.syncEndDate" name="syncEndDate" />
                                    <date-picker id="input-enddate"
                                                 v-model="searchForm.syncEndDate"
                                                 class="col-6 no-padding"
                                                 placeholder="dd/mm/yyyy">
                                    </date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportSync.unitCurrency">
                            <b-col offset-md="2">
                                <b-form-group label="Đơn vị tính giá trị:"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <div class="col-6 p-l-r-0">
                                        <select2 :options="listUnitCurrencys" name="unitCurrency"
                                                 v-model="searchForm.unitCurrency"
                                                 placeholder="---chọn---">
                                        </select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportSync.unitArea">
                            <b-col offset-md="2">
                                <b-form-group label="Đơn vị tính diện tích:"
                                              label-for="input-reportyear"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <div class="col-6 p-l-r-0">
                                        <input type="hidden" v-model="searchForm.unitArea" name="unitArea" :state="false" />
                                        <!--<b-form-input type="text" style="display: none"
                                                      aria-describedby="reportDateFeedback"
                                                      v-model="$v.searchForm.unitArea.$model"
                                                      :state="false">
                                        </b-form-input>-->
                                        <select2 :options="listUnitArea" name="unitArea"
                                                 placeholder="--- chọn ---"
                                                 v-model="searchForm.unitArea"></select2>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn đơn vị tính
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportSync.area">
                            <b-col offset-md="2">
                                <b-form-group label="Đơn vị tính số lượng:"
                                              label-for="input-quantity"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-6 p-l-r-0">
                                        <select2 :options="listUnitQuantity" name="unitQuantity"
                                                 allowClear="true"
                                                 v-model="searchForm.unitQuantity">
                                        </select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>


                        <b-row v-if="reportSync.administrativeLevel">
                            <b-col offset-md="2">
                                <b-form-group label=""
                                              label-for="input-quantity"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-radio-group v-model="searchForm.administrativeLevel"
                                                        name="administrativeLevel">
                                        <b-form-radio :value="1">Trung ương</b-form-radio>
                                        <b-form-radio :value="2">Địa phương</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="searchForm.administrativeLevel == 2">
                            <b-col offset-md="2">
                                <b-form-group label="Địa bàn:"
                                              label-for="region"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <input type="hidden" v-model="searchForm.regionId" name="regionId" />
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="reportDateFeedback"
                                                  v-model="$v.searchForm.regionId.$model"
                                                  :state="$v.searchForm.regionId.$dirty ? !$v.searchForm.regionId.$error : null">
                                    </b-form-input>
                                    <region-tree v-model="searchForm.regionId"
                                                 class="no-padding col-6"
                                                 ref="regionTree"></region-tree>
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn địa bàn
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportSync.handlingType">
                            <b-col offset-md="2">
                                <b-form-group label="Hình thức xử lý:"
                                              label-for="input-quantity"
                                              :label-cols="4" label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <div class="col-6 p-l-r-0">
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="unitTypeFeedback"
                                                      v-model="$v.searchForm.handlingType.$model"
                                                      :state="$v.searchForm.handlingType.$dirty ? !$v.searchForm.handlingType.$error : null"></b-form-input>
                                        <select2 v-if="handlingTypes.length > 0" :options="handlingTypes" name="handlingType"
                                                 v-model="searchForm.handlingType"
                                                 placeholder="--- Chọn ---"
                                                 allowClear="true"></select2>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn hình thức xử lý
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--6 báo cáo mới sở hữu toàn dân-->
                        <template v-if="reportSync.decisionNumber == 1">
                            <b-row>
                                <b-col offset-md="2">
                                    <b-form-group label="Số quyết định:"
                                                  label-for="input-reportdate"
                                                  :label-cols="4" label-cols-md="3"
                                                  :horizontal="true"
                                                  label-align="left"
                                                  label-class="required">
                                        <div class="col-6 no-padding">
                                            <b-form-input type="text" name="decisionNumber"
                                                          aria-describedby="reportDateFeedback"
                                                          v-model="$v.searchForm.decisionNumber.$model"
                                                          :state="$v.searchForm.decisionNumber.$dirty ? !$v.searchForm.decisionNumber.$error : null">
                                            </b-form-input>
                                            <b-form-invalid-feedback>
                                                Vui lòng nhập số quyết định
                                            </b-form-invalid-feedback>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </template>

                        <!--Form yêu cầu báo cáo đột xuất -->
                        <!--<template v-if="isShowFormReportRequest">
                            <b-row>
                                <b-col offset-md="2">
                                    <b-form-group label="Nguồn báo cáo:"
                                                  title="Nguồn báo cáo (3 hệ thống QLTSC/CTNS/HTGTĐB)"
                                                  :label-cols="4" label-cols-md="3"
                                                  :horizontal="true"
                                                  label-align="left"
                                                  label-class="required">-->
                        <!--<b-col md="6 no-padding">-->
                        <!--<div class="col-6 no-padding">
                            <b-form-input type="text" style="display: none"
                                          v-model="$v.reportRequest.syncDataSourceId.$model"
                                          :state="$v.reportRequest.syncDataSourceId.$dirty? !$v.reportRequest.syncDataSourceId.$error : null"></b-form-input>
                            <select2 placeholder="--- Chọn nguồn báo cáo ---"
                                     v-if="listSyncDataSources.length > 0"
                                     v-model="$v.reportRequest.syncDataSourceId.$model"
                                     :options="listSyncDataSources" allowClear></select2>
                            <b-form-invalid-feedback>
                                Nguồn báo cáo không không được để trống
                            </b-form-invalid-feedback>
                        </div>-->
                        <!--</b-col>-->
                        <!--</b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col offset-md="2">
                                    <b-form-group label="Định dạng dữ liệu trả về:"
                                                  label-for="input-reportyear"
                                                  :label-cols="4" label-cols-md="3"
                                                  :horizontal="true"
                                                  label-align="left"
                                                  label-class="required">
                                        <b-form-select class="col-6 no-padding" title="Định dạng dữ liệu trả về khi yêu cầu báo cáo" v-model="reportRequest.LOAI_DATA_TRA_VE"
                                                       :state="$v.reportRequest.LOAI_DATA_TRA_VE.$dirty? !$v.reportRequest.LOAI_DATA_TRA_VE.$error : null"
                                                       :options="loaiDataTraVeIds"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </template>-->
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="" :label-cols="4" label-cols-md="3">
                                    <!--<b-button type="button" variant="primary" @click="search(false)">Xuất báo cáo</b-button>-->
                                    <b-button type="button" variant="primary" @click="search(true)">Xuất báo cáo</b-button>
                                    <b-button size="md" v-b-modal.reportRequestModal
                                              v-if="isShowBtnReportRequest"
                                              variant="primary">
                                        Yêu cầu báo cáo đột xuất
                                    </b-button>
                                    <b-button type="button" variant="secondary" :to="{ path: `/view-reports/${pathReportType}/list` }">Thoát</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>

                    <b-grid :gridOptions="gridOptions"
                            :searchForm="searchForm"
                            dataUrl="data/reports/available"
                            gridName="Danh sách báo cáo đã đồng bộ"
                            :onGridRefresh="onGridRefresh"
                            :autoLoad="false"
                            ref="reportsTable">
                        <!--<template v-slot:actions>
                            <b-form-input type="text" v-model="filter" placeholder="Nhập điều kiện lọc"></b-form-input>
                        </template>-->
                        <template v-slot:cell(syncDate)="row">
                            {{ row.item.syncDate | formatTime }}
                        </template>
                        <template v-slot:cell(reportDate)="row">
                            {{ getReportDate(row.item) }}
                        </template>
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.value) }}
                        </template>

                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <!--<b-button size="sm" title="xem" @click="viewReport(row.item)" variant="info">
                                    Xem
                                </b-button>-->
                                <b-button v-if="authorize(['ViewReport'])" size="sm" title="Xem" @click="viewReport(row.item, true)" variant="info">
                                    Xem
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>

                    <!--<template>
                        <b-row>
                            <b-button size="md" @click="combineReport" variant="primary">
                                Tổng hợp báo cáo
                            </b-button>
                            <b-button size="md" v-b-modal.reportRequestModal variant="primary">
                                Yêu cầu báo cáo đột xuất
                            </b-button>
                        </b-row>
                    </template>-->

                    <div v-if="reportSrc">
                        <iframe :src="reportSrc"></iframe>
                    </div>


                    <b-modal :no-enforce-focus="true" id="reportRequestModal"
                             size="lg"
                             title="Yêu cầu báo cáo đột xuất"
                             no-close-on-backdrop>
                        <b-row>
                            <b-col>
                                <b-form-group label="Nguồn báo cáo:"
                                              title="Nguồn báo cáo (3 hệ thống QLTSC/CTNS/HTGTĐB)"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-col md="no-padding">
                                        <b-form-input type="text" style="display: none"
                                                      v-model="$v.reportRequest.syncDataSourceId.$model"
                                                      :state="$v.reportRequest.syncDataSourceId.$dirty? !$v.reportRequest.syncDataSourceId.$error : null"></b-form-input>
                                        <select2 placeholder="--- Chọn nguồn báo cáo ---"
                                                 v-if="listSyncDataSources.length > 0"
                                                 v-model="$v.reportRequest.syncDataSourceId.$model"
                                                 :options="listSyncDataSources"></select2>
                                        <b-form-invalid-feedback>
                                            Nguồn báo cáo không được để trống
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportRequest.syncDataSourceId">
                            <b-col>
                                <b-form-group label="Đơn vị xuất báo cáo:"
                                              label-for="input-unit"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <input type="hidden" name="listDonViIds" v-model="reportRequest.listDonViIds" />
                                    <b-form-input type="text" style="display: none"
                                                  v-model="$v.reportRequest.listDonViIds.$model"
                                                  :state="$v.reportRequest.listDonViIds.$dirty? !$v.reportRequest.listDonViIds.$error : null"></b-form-input>
                                    <unit-tree ref="unitTree" v-model="reportRequest.listDonViIds"
                                               :syncSourceType="reportRequest.syncDataSourceId"
                                               class="no-padding"></unit-tree>
                                    <b-form-invalid-feedback>
                                        Đơn vị không được để trống
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>


                        <!--<b-row>
                            <b-col>
                                <b-form-group label="Định dạng dữ liệu trả về:"
                                              label-for="input-reportyear"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <b-form-select title="Định dạng dữ liệu trả về khi yêu cầu báo cáo" v-model="reportRequest.LOAI_DATA_TRA_VE"
                                                   :state="$v.reportRequest.LOAI_DATA_TRA_VE.$dirty? !$v.reportRequest.LOAI_DATA_TRA_VE.$error : null"
                                                   :options="loaiDataTraVeIds"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <!--<b-row>
                            <b-col>
                                <b-form-group label="Đơn vị tính giá trị:"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="p-l-r-0">
                                        <select2 :options="listUnitCurrencys" name="unitCurrency"
                                                 v-model="reportRequest.DON_VI_TINH_GIA_TRI"
                                                 placeholder="---chọn---">
                                        </select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Đơn vị tính diện tích:"
                                              label-for="input-reportyear"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="p-l-r-0">
                                        <input type="hidden" v-model="searchForm.DON_VI_TINH_DIEN_TICH" name="unitArea" :state="false" />
                                        <select2 :options="listUnitArea" name="unitArea"
                                                 placeholder="--- chọn ---"
                                                 v-model="reportRequest.unitArea"></select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>-->

                        <b-row v-if="reportRequestIsConfig.periodType == 1">
                            <b-col>
                                <b-form-group label="Ngày báo cáo:"
                                              label-for="input-reportdate"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <div class="no-padding">
                                        <input type="hidden" v-model="reportRequest.NGAY_BAO_CAO" name="NGAY_BAO_CAO" />
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="reportDateFeedback"
                                                      v-model="$v.reportRequest.NGAY_BAO_CAO.$model"
                                                      :state="$v.reportRequest.NGAY_BAO_CAO.$dirty ? !$v.reportRequest.NGAY_BAO_CAO.$error : null">
                                        </b-form-input>
                                        <date-picker v-model="reportRequest.NGAY_BAO_CAO" placeholder="dd/mm/yyyy">
                                        </date-picker>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn ngày báo cáo
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportRequestIsConfig.periodType == 2">
                            <b-col>
                                <b-form-group label="Số liệu báo cáo từ ngày:"
                                              label-for="input-startdate"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <input type="hidden" v-model="reportRequest.TU_NGAY" name="reportStartDate" />
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="reportDateFeedback"
                                                  v-model="$v.reportRequest.TU_NGAY.$model"
                                                  :state="$v.reportRequest.TU_NGAY.$dirty ? !$v.reportRequest.TU_NGAY.$error : null">
                                    </b-form-input>
                                    <date-picker id="input-startdate"
                                                 v-model="reportRequest.TU_NGAY"
                                                 class="no-padding"
                                                 placeholder="dd/mm/yyyy">
                                    </date-picker>
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn từ ngày
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportRequestIsConfig.periodType == 2">
                            <b-col>
                                <b-form-group label="Đến ngày:"
                                              label-for="input-enddate"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <input type="hidden" v-model="reportRequest.DEN_NGAY" name="reportEndDate" />
                                    <b-form-input type="text" style="display: none"
                                                  aria-describedby="reportDateFeedback"
                                                  v-model="$v.reportRequest.DEN_NGAY.$model"
                                                  :state="$v.reportRequest.DEN_NGAY.$dirty ? !$v.reportRequest.DEN_NGAY.$error : null">
                                    </b-form-input>
                                    <date-picker id="input-enddate"
                                                 v-model="reportRequest.DEN_NGAY"
                                                 class="no-padding"
                                                 placeholder="dd/mm/yyyy">
                                    </date-picker>
                                    <b-form-invalid-feedback>
                                        Vui lòng chọn đến ngày
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="reportRequestIsConfig.periodType == 3">
                            <b-col>
                                <b-form-group label="Năm báo cáo:"
                                              label-for="input-reportyear"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <input type="hidden" v-model="reportRequest.NAM" name="reportYear" />
                                    <b-form-input type="number" class="" min="2000"
                                                  aria-describedby="reportDateFeedback"
                                                  v-model="$v.reportRequest.NAM.$model"
                                                  :state="$v.reportRequest.NAM.$dirty ? !$v.reportRequest.NAM.$error : null">
                                    </b-form-input>
                                    <!--<date-picker type="year" id="input-reportyear" format="YYYY" valueType="format"
                                                 v-model="$v.searchForm.reportYear.$model"
                                                 class="col-6 no-padding">
                                    </date-picker>-->
                                    <b-form-invalid-feedback>
                                        <span v-if="reportRequest.NAM== ''">Vui lòng chọn năm báo cáo</span>
                                        <span v-if="reportRequest.NAM < 0">Vui lòng nhập giá trị hợp lệ</span>
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <template #modal-footer="{ ok, cancel, hide }">
                            <b-button variant="primary" @click="fortuityReport">
                                Gửi yêu cầu
                            </b-button>
                            <b-button variant="secondary" @click="cancel()">
                                Hủy
                            </b-button>
                        </template>
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    import { minValue } from 'vuelidate/lib/validators'
    import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'

    export default {
        name: 'ReportDetail',
        mixins: [mixins],
        data() {
            return {
                listUnitCurrencys: [{ text: 'Đồng', id: '1' }, { text: 'Nghìn đồng', id: "2" }, { text: 'Triệu đồng', id: '3' }, { text: 'Tỷ đồng', id: '4' }],
                listUnitArea: [{ text: 'm²', id: '1' }, { text: 'Nghìn m²', id: '2' }, { text: 'Mười nghìn m²', id: '3' }],
                listUnitQuantity: [{ text: 'Cái/Khuôn viên', id: '1' }],
                title: "",
                searchForm: {
                    reportTypeId: this.$route.params.reportTypeId,
                    unitCurrency: 1,
                    syncSourceType: [],
                    reportStartDate: this.$route.query.reportStartDate ? new Date(this.$route.query.reportStartDate).formatDate() : new Date(new Date().getFullYear(), 0, 1).formatDate(),
                    reportEndDate: this.$route.query.reportEndDate ? new Date(this.$route.query.reportEndDate).formatDate() : new Date().formatDate(),
                    reportDate: this.$route.query.reportDate ? new Date(this.$route.query.reportDate).formatDate() : new Date().formatDate(),
                    reportYear: this.$route.query.reportYear ?? new Date().getFullYear().toString(),
                    syncStartDate: null,
                    syncEndDate: new Date().formatDate(),
                    unitId: null,
                    //unitTraversalOption: null,
                    unitArea: 1,
                    unitQuantity: 1,
                    administrativeLevel: this.$route.query.administrativeLevel ?? 1,
                    regionId: typeof (this.$route.query.regionId) == "string" ? parseInt(this.$route.query.regionId) : null,
                    handlingType: this.$route.query.handlingType ?? null,
                    assetTypeGroupId: this.$route.query.assetTypeGroupId ?? [],
                    decisionNumber: this.$route.query.decisionNumber ?? null,
                    assetSourceId: this.$route.query.assetSourceId ? this.$route.query.assetSourceId : [],
                    assetTypeLevel: this.$route.query.assetTypeLevel ? this.$route.query.assetTypeLevel : 1,
                    unitLevel: this.$route.query.unitLevel ? this.$route.query.unitLevel : 1,
                },
                pathReportType: '',
                handlingTypes: [
                    { id: 1, text: "Bán" },
                    { id: 2, text: "Thanh lý" },
                    { id: 3, text: "Điều chuyển" },
                    { id: 4, text: "Thu hồi" },
                    { id: 5, text: "Sử dụng tài sản để thanh toán cho nhà đầu tư theo hình thức BT" },
                    { id: 6, text: "Bị mất / bị hủy hoại" },
                    { id: 7, text: "Hình thức xử lý khác" },
                ],
                gridOptions: {
                    fields: [
                        { key: 'reportTypeName', label: 'Mẫu báo cáo', sortable: false, sortDirection: 'asc' },
                        { key: 'reportedUnitName', label: 'Tên đơn vị', sortable: false, sortDirection: 'asc', tdAttr: (key, value, item) => ({ title: item.reportedUnitFullName }) },
                        { key: 'assetTypeGroupName', label: 'Nhóm tài sản lớn', sortable: false },
                        { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: false },
                        { key: 'syncDate', label: 'Ngày đồng bộ', sortable: false, sortDirection: 'asc' },
                        { key: 'reportDate', label: 'Ngày báo cáo ', sortable: false, sortDirection: 'asc' },

                    ],
                    page: 1,
                    itemsPerPage: 10,
                    totalRows: this.items ? this.items.length : 0,
                    pageOptions: [10, 20, 50, 100],
                    sortBy: 'reportedUnitName',
                    sortDirection: 'asc'
                },
                availableReports: [],
                filter: null,
                reportSrc: null,
                loaiDataTraVeIds: [
                    { value: 0, text: "Định dạng word .docx" },
                    { value: 1, text: "Định dạng excel .xlsx" },
                    { value: 2, text: "Định dạng pdf" },
                    { value: 3, text: "Định dạng json" }
                ],
                reportRequest: {
                    reportTypeId: this.$route.params.reportTypeId,
                    syncDataSourceId: null,
                    //DON_VI_TINH_GIA_TRI: 1,
                    //DON_VI_TINH_DIEN_TICH: 1
                    LOAI_DATA_TRA_VE: 3,
                    DON_VI_TINH_GIA_TRI: null,
                    DON_VI_TINH_DIEN_TICH: null,
                    DON_VI_TINH_SO_LUONG: null,
                    NGAY_BAO_CAO: null,
                    TU_NGAY: null,
                    DEN_NGAY: null,
                    NAM: null,
                    listDonViIds: null
                },
                isShowBtnReportRequest: false,
                reportRequestIsConfig: {
                    periodType: null
                },
                listSyncDataSources: []
            }
        },
        validations: {
            searchForm: {
                //unitId: {
                //    requiredIf: (function () {
                //        return !(this.reportSync.unitTree && !this.searchForm.unitId);
                //    })
                //},
                reportStartDate: {
                    requiredIf: (function () {
                        return !((this.reportSync.periodType == 2 || this.reportSync.periodType == 1) && !this.searchForm.reportStartDate);
                    })
                },
                reportEndDate: {
                    requiredIf: (function () {
                        return !((this.reportSync.periodType == 2 || this.reportSync.periodType == 1) && !this.reportSync.reportYear && !this.searchForm.reportEndDate);
                    })
                },
                //reportDate: {
                //    requiredIf: (function () {
                //        return !(this.reportSync.periodType == 1 && !this.searchForm.reportDate);
                //    })
                //},
                //reportYear: {
                //    requiredIf: (function () {
                //        return !(this.reportSync.periodType == 3 && !this.searchForm.reportYear);
                //    }),
                //},
                reportYear: {
                    requiredIf: (function () {

                        return !(this.reportSync.periodType == 3 && !this.searchForm.reportYear);
                    }),
                    minValue: minValue(0)
                },
                assetType: {
                    requiredIf: (function () {
                        return !(this.reportSync.assetType && !this.searchForm.assetType);
                    })
                },
                administrativeLevel: {
                    requiredIf: (function () {
                        return !(this.reportSync.administrativeLevel && !this.searchForm.administrativeLevel);
                    })
                },
                regionId: {
                    requiredIf: (function () {
                        return !(this.searchForm.administrativeLevel == 2 && !this.searchForm.regionId);
                    })
                },
                handlingType: {
                    requiredIf: (function () {
                        return !(this.reportSync.handlingType && !this.searchForm.handlingType);
                    })
                },
                //assetTypeGroupId: {
                //    requiredIf: (function () {
                //        return !(this.reportSync.assetTypeGroupId && !this.searchForm.assetTypeGroupId);
                //    })

                //},
                decisionNumber: {
                    requiredIf: (function () {
                        return !(this.reportSync.decisionNumber && !this.searchForm.decisionNumber);
                    })

                },
                assetTypeLevel: {

                    requiredIf: (function () {
                        //return (this.searchForm.assetTypeLevel == 1 || this.searchForm.assetTypeLevel == 2);
                        return (this.searchForm.assetTypeLevel >= 0);
                    })
                },
                unitLevel: {
                    requiredIf: (function () {
                        return (this.searchForm.unitLevel >= 0);
                    })
                },
            },
            reportRequest: {
                syncDataSourceId: {
                    required
                },
                LOAI_DATA_TRA_VE: {
                    required
                },
                NAM: {
                    requiredIf: (function () {
                        return !(this.reportRequestIsConfig.periodType == 3 && !this.reportRequest.NAM);
                    }),
                    minValue: minValue(0)
                },
                TU_NGAY: {
                    requiredIf: (function () {
                        return !((this.reportRequestIsConfig.periodType == 2) && !this.reportRequest.TU_NGAY);
                    })
                },
                DEN_NGAY: {
                    requiredIf: (function () {
                        return !((this.reportRequestIsConfig.periodType == 2) && !this.reportSync.reportYear && !this.reportRequest.DEN_NGAY);
                    })
                },
                NGAY_BAO_CAO: {
                    requiredIf: (function () {
                        return !(this.reportRequestIsConfig.periodType == 1 && !this.reportRequest.NGAY_BAO_CAO);
                    })
                },
                listDonViIds: {
                    requiredIf: (function () {
                        return !(this.reportSync.unitTree && !this.reportRequest.listDonViIds);
                    })
                },
            },
            flagCombineReport: false
        },
        computed: {
            //listReportAssetTypeLevel() {
            //    return this.$store.getters.reportAssetTypeLevel(this.searchForm.reportTypeId == "44" ? 2 : 1);
            //},
            ...mapState({
                listReportAssetTypeLevel: (state) => state.common.listReportAssetTypeLevel,
                listReportUnitLevel: (state) => state.common.listReportUnitLevel,
                topLevelUnits: (state) => state.common.topLevelUnits,
                listSyncDataSourceFulls: (state, getters) => getters.getSyncDataSources,
                listSyncSourceTypes: function (state) {
                    var result = state.common.listSyncSourceTypes;

                    if (this.reportSync && this.reportSync.syncSourceType) {
                        result = result.filter(x => this.reportSync.syncSourceType.indexOf(x.id) != -1);
                    } else {
                        result = [];
                    }

                    return result;
                },
                //assetSources: (state, getters) => getters.assetSourceTree,
                /*assetSources: (state, getters) => state.common.assetSources.filter(x => x.parentId == null && x.assetSourceGroup == 2).map(x => { return { id: x.id, text: x.name }; }),*/
                assetSources: (state, getters) => state.common.assetSources.filter(x => x.parentId == null && x.appliedAssetTypeGroupIds != undefined && x.appliedAssetTypeGroupIds.indexOf(2) != -1).map(x => { return { id: x.id, text: x.name }; }),
                assetTypeGroups: function (state, getters) {
                    return state.common.assetTypeGroups.filter(x => x.parentId == this.reportSync.assetTypeGroupId).map(x => { return { id: x.id, text: x.name }; });
                }
                /*getters.assetSourceTree.filter(x => x.appliedAssetTypeGroupIds != undefined && x.appliedAssetTypeGroupIds.indexOf(this.assetTypeGroupId) != -1);*/
            }),
            listReportSyncTypes() {
                if (this.$route.meta.infoTypes) {
                    var types = JSON.parse(JSON.stringify(this.$store.state.common.listReportSyncTypes));

                    return types.filter(x => this.$route.meta.infoTypes.indexOf(x.id) != -1);
                } else {
                    return this.$store.state.common.listReportSyncTypes;
                }
            },
            reportSync() {
                var vm = this;
                var reportInfo = this.$store.getters.getReportSyncType(this.searchForm.reportTypeId);

                //if (reportInfo.allowUnion) {
                //if (this.gridOptions.fields[0].key != 'rowSelected') {
                //    this.gridOptions.fields.splice(0, 0, { key: 'rowSelected', sortable: false });
                //}
                //}

                //if (reportInfo.syncSourceType && reportInfo.syncSourceType.length > 0) {
                //    this.searchForm.syncSourceType = reportInfo.syncSourceType[0].id;
                //}

                //this.searchForm.syncSourceType = reportInfo.syncSourceType;

                //if (this.searchForm.syncSourceType.length == 1) {
                //    this.searchForm.unitId = this.getUnitTreeIdCache(this.searchForm.syncSourceType[0]);
                //    this.searchForm.unitTraversalOption = this.getUnitTreeTraversalOptionCache();
                //} else {
                //    this.searchForm.unitId = this.getTopLevelUnitIdCache();
                //}

                return reportInfo;
            },
            filteredReports() {
                var filter = this.filter;
                if (filter && filter.length >= 3) {
                    return this.availableReports.filter(x => x.reportedUnitName.latinize().toLowerCase().indexOf(filter.latinize().toLowerCase()) != -1);
                } else {
                    return this.availableReports;
                }
            },
            visibleReports() {
                return this.filteredReports.slice(this.firstItem - 1, this.lastItem);
            },
            groupReports() {
                //return this._.groupBy(this.visibleReports, 'reportedUnitId');

                return this.allGroupReports.slice(this.firstItem - 1, this.lastItem);
            },
            allGroupReports() {

                var groups = this._.groupBy(this.filteredReports, 'reportedUnitId');
                var result = [];

                for (var key in groups) {
                    result.push(groups[key]);
                }

                return result;
            },
            selectedReports() {
                return this.availableReports;
                //return this.$refs.reportsTable ? this.$refs.reportsTable.selectedRows : [];
                //return this.availableReports.filter(x => x.rowSelected);
            },

            firstItem() {
                return (this.gridOptions.page - 1) * this.gridOptions.itemsPerPage + 1;
            },
            lastItem() {
                return Math.min(this.totalRows, this.gridOptions.page * this.gridOptions.itemsPerPage);
            },
            totalRows() {
                return this.allGroupReports.length;
            },
            //listSyncDataSources() {
            //    debugger;

            //    var syncDataSourceIds = this.reportRequestIsConfig.map(x => x.syncDataSourceId);
            //    return this.$store.getters.getSyncDataSources.filter(x => syncDataSourceIds.indexOf(x.id) != -1);

            //},
            showUnitTree() {
                if (this.searchForm.syncSourceType.length == 1)
                    return true;
                if (this.searchForm.syncSourceType.length > 1 && this.searchForm.syncSourceType.map(x => parseInt(x)).find(x => [1, 2].indexOf(x) == -1) == null)
                    return true;
                if (this.reportSync.syncSourceType.length == 1)
                    return true;
                if (this.reportSync.syncSourceType.find(x => [1, 2].indexOf(x) == -1) == null)
                    return true;

                return false;
            }
        },
        created() {
            if (this.reportSync) {
                var privileges = this.$store.state.identity.privileges;
                if (privileges.indexOf('ViewReport_' + this.reportSync.table.substr(4)) == -1) {
                    this.$router.push('/');
                }
                this.title = this.reportSync.text;
                this.pathReportType = this.$route.meta.pathReportType;
            }

            if (this.searchForm.unitId) {
                this.reportRequest.listDonViIds = this.searchForm.unitId;
            }
            // load danh sách cấu hình định kỳ theo loại báo cáo
            this.loadReportRequestParameterByReportTypeId(this.$route.params.reportTypeId);
        },
        watch: {
            'searchForm.administrativeLevel'() {
                return this.searchForm.regionId = null;
            },
            'searchForm.assetTypeLevel'() {
                return this.searchForm.assetTypeLevel > 0 ? true : false
            },
            'searchForm.unitLevel'() {
                return this.searchForm.unitLevel > 0 ? true : false
            },
            reportSync(val) {
                if (val == null) {
                    this.$router.push('/');
                } else {
                    var privileges = this.$store.state.identity.privileges;
                    if (privileges.indexOf('ViewReport_' + this.reportSync.table.substr(4)) == -1) {
                        this.$router.push('/');
                    }
                    this.title = this.reportSync.text;
                    this.pathReportType = this.$route.meta.pathReportType;
                }
            },
            title(val) {
                this.$route.meta.label = this.reportSync.title;
                this.$store.dispatch('updateBreadcrumb');
            },
            'searchForm.unitId'(val) {
                this.reportRequest.listDonViIds = val;
            },
            //'reportRequest.syncDataSourceId'(val) {
            //    if (val != 1) {
            //        this.reportRequest.TU_NGAY = new Date().formatDate();
            //        this.isDisabled = true;
            //    }
            //    else {
            //        this.reportRequest.TU_NGAY = null;
            //        this.isDisabled = false;
            //    }
            //}

        },
        methods: {
            search() {
                this.$v.searchForm.$touch();
                var vm = this;
                if (!vm.$v.searchForm.$invalid) {
                    var vm = this;
                    //var formData = $("#reportForm").serialize();

                    // Remove tiêu chí lọc ko sử dụng dựa theo loại báo cáo
                    if (!this.reportSync.administrativeLevel) {
                        this.searchForm.administrativeLevel = null;
                    }

                    if (this.reportSync.periodType != 3) {
                        this.searchForm.reportYear = null;
                    } else {
                        this.searchForm.reportStartDate = null;
                        this.searchForm.reportEndDate = null;
                    }

                    vm.flagCombineReport = true;

                    vm.$refs.reportsTable.refresh();

                    //this.$services.get(`data/reports/available?reportTypeId=${this.searchForm.reportTypeId}`, vm.searchForm).done((response) => {
                    //    response.forEach(item => item.rowSelected = false);
                    //    vm.$refs.reportsTable.refresh();
                    //    vm.availableReports = response;

                    //    vm.combineReport();
                    //});
                }
            },
            onGridRefresh(response) {
                if (this.flagCombineReport) {
                    this.flagCombineReport = false;
                    if (response.totalRows > 0) {
                        this.combineReport(response.data.map(x => x.id));
                    } else {
                        this.$toastr.w('Không tìm thấy báo cáo phù hợp.')
                    }
                }
            },
            viewReport(data) {
                this.$v.$touch();
                var vm = this;
                if (!vm.$v.searchForm.$invalid) {
                    var vm = this;

                    var jsonParameter = {
                        reportId: data.id,
                        userid: this.$store.state.identity.userId
                    };

                    //var queryString = 'reportId=' + data.id;
                    var reportSyncType = this.$store.getters.getReportSyncType(vm.searchForm.reportTypeId);

                    switch (reportSyncType.periodType) {
                        case 1:
                            //queryString += `&reportDate=${formatDate(data.reportEndDate, 'YYYY-MM-DD')}`;
                            jsonParameter.reportDate = formatDate(data.reportEndDate, 'YYYY-MM-DD');
                            break; // báo cáo theo ngày
                        case 2:
                            //queryString += `&reportStartDate=${formatDate(data.reportStartDate, 'YYYY-MM-DD')}&reportEndDate=${formatDate(data.reportEndDate, 'YYYY-MM-DD')}`;
                            jsonParameter.reportStartDate = formatDate(data.reportStartDate, 'YYYY-MM-DD');
                            jsonParameter.reportEndDate = formatDate(data.reportEndDate, 'YYYY-MM-DD');
                            break; // báo cáo theo khoảng ngày
                        case 3:
                            //queryString += `&reportYear=${data.reportYear}`;
                            jsonParameter.reportYear = data.reportYear;
                            break; // báo cáo theo năm
                    }



                    if (reportSyncType.handlingType) {
                        //queryString += `&handlingType=${data.handlingType || ''}`;
                        jsonParameter.handlingType = data.handlingType;
                    }

                    if (reportSyncType.administrativeLevel) {
                        //queryString += `&administrativeLevel=${data.administrativeLevel}&regionId=${data.regionId}`;
                        jsonParameter.administrativeLevel = data.administrativeLevel;
                    }

                    if (this.searchForm.assetTypeGroupId) {
                        //queryString += `&assetTypeGroupId=[${this.searchForm.assetTypeGroupId.join(',') || ''}]`;
                        jsonParameter.assetTypeGroupId = this.searchForm.assetTypeGroupId || [];
                    } else if (reportSyncType.assetTypeGroupId) {
                        //queryString += `&assetTypeGroupId=[${data.assetTypeGroupId.join(',') || ''}]`;
                        jsonParameter.assetTypeGroupId = data.assetTypeGroupId ? [data.assetTypeGroupId] : [];
                    }

                    if (this.searchForm.unitCurrency) {
                        //queryString += `&unitCurrency=${this.searchForm.unitCurrency}`;
                        jsonParameter.unitCurrency = this.searchForm.unitCurrency;
                    }

                    if (this.searchForm.unitArea) {
                        //queryString += `&unitArea=${this.searchForm.unitArea}`;
                        jsonParameter.unitArea = this.searchForm.unitArea;
                    }

                    if (this.searchForm.assetSourceId) {
                        //queryString += `&assetSourceId=${this.searchForm.assetSourceId.join(',') || ''}`;
                        jsonParameter.assetSourceId = this.searchForm.assetSourceId || [];
                    }

                    if (this.searchForm.assetTypeLevel) {
                        //queryString += `&assetTypeLevel=${this.searchForm.assetTypeLevel || ''}`;
                        jsonParameter.assetTypeLevel = this.searchForm.assetTypeLevel;
                    }

                    if (this.searchForm.unitLevel) {
                        //queryString += `&unitLevel=${this.searchForm.unitLevel || ''}`;
                        jsonParameter.unitLevel = this.searchForm.unitLevel;
                    }

                    if (reportSyncType.decisionNumber) {
                        //queryString += `&decisionNumber=${data.decisionNumber || ''}`;
                        jsonParameter.decisionNumber = data.decisionNumber;
                    }

                    //queryString += `&userid=${this.$store.state.identity.userId}`;

                    //var jsonParameter = JSON.parse('{"' + decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

                    if (this.$services.USE_ORACLE_BI) {
                        window.open(this.$services.getOracleBIPUrl(reportSyncType.code, reportSyncType.code.substr(reportSyncType.code.indexOf('/') + 1), jsonParameter))
                    } else {
                        window.open(`${this.$services.REPORT_END_POINT}${reportSyncType.code}.aspx?parameter=${encodeURI(JSON.stringify(jsonParameter))}`);
                    }
                }
            },
            combineReport(reportIds) {
                this.$v.searchForm.$touch();
                var vm = this;
                //if (this.$refs.reportsTable.items.length == 0) {
                //    this.$toastr.w('Không tìm thấy báo cáo phù hợp.')
                //    //this.$toastr.w('Vui lòng chọn báo cáo để tổng hợp')
                //    return;
                //}

                //if (!vm.$v.searchForm.$invalid) {
                var vm = this;
                var code = vm.$store.getters.getReportSyncType(vm.searchForm.reportTypeId).code;
                var url = vm.$services.REPORT_END_POINT;

                /*var queryString = `reportId=${this.selectedReports.map(x => x.id).join(',')}&unitId=${vm.searchForm.unitId}&reportDate=${vm.searchForm.reportDate || ''}&reportStartDate=${vm.searchForm.reportStartDate}&reportEndDate=${vm.searchForm.reportEndDate}&unitCurrency=${vm.searchForm.unitCurrency}&unitArea=${vm.searchForm.unitArea}&unitQuantity=${vm.searchForm.unitQuantity}&reportYear=${new Date(vm.searchForm.reportYear).getFullYear() || ''}&reportRegion=${vm.searchForm.regionId || ''}&administrativeLevel=${vm.searchForm.administrativeLevel || ''}&handlingType=${vm.searchForm.handlingType || ''}&assetTypeGroupId=${vm.searchForm.assetTypeGroupId.join(',') || ''}&decisionNumber=${vm.searchForm.decisionNumber || ''}&assetSourceId=${vm.searchForm.assetSourceId.join(',') || ''}&assetTypeLevel=${vm.searchForm.assetTypeLevel || ''}&unitLevel=${vm.searchForm.unitLevel || ''}`;*/

                var jsonParameter = vm.searchForm;
                jsonParameter.userid = this.$store.state.identity.userId;
                jsonParameter.reportIds = reportIds.join(',');

                if (this.$services.USE_ORACLE_BI) {
                    //var jsonParameter = JSON.parse('{"' + decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

                    window.open(this.$services.getOracleBIPUrl(code, code.substr(code.indexOf('/') + 1), jsonParameter))
                } else {
                    window.open(`${url}${code}.aspx?parameter=${encodeURI(JSON.stringify(jsonParameter))}`);
                }
                //}
            },
            fortuityReport() {
                this.$v.reportRequest.$touch();
                var vm = this;
                if (!vm.$v.reportRequest.$invalid) {
                    var query = {
                        //listDonViIds: vm.searchForm.unitId || vm.$store.state.identity.unitId,
                        DON_VI_TINH_GIA_TRI: 1, //Đồng
                        DON_VI_TINH_DIEN_TICH: 1, //m2
                        DON_VI_TINH_SO_LUONG: '',
                        listLoaiDonViIds: "11,12,13,14,15",
                        //NGAY_BAO_CAO: vm.searchForm.reportDate || '',
                        //TU_NGAY: vm.searchForm.reportStartDate || '',
                        //DEN_NGAY: vm.searchForm.reportEndDate || '',
                        //NAM: new Date(vm.searchForm.reportYear).getFullYear() || '',
                        //BAC_DON_VI: vm.searchForm.unitLevel || '',
                        //BAC_TAI_SAN: vm.searchForm.assetTypeLevel || '',
                        //listLoaiHinhTaiSanIds: vm.searchForm.assetTypeGroupId.join(',') || '',
                        ...vm.reportRequest
                    };

                    vm.$services.post(`data/reports/fortuity-report`, query).done(
                        (response) => {
                            if (response) {
                                vm.$toastr.s('Yêu cầu báo cáo thành công!');
                                vm.hideModalAndReset();
                            }
                            else {
                                vm.$toastr.e('Đã xảy ra lỗi khi yêu cầu báo cáo!');
                            }
                        });
                }
            },
            getReportDate(report) {
                var reportType = this.$store.getters.getReportSyncType(report.reportTypeId);
                var format = defaultDisplayFormatDate;
                switch (reportType.periodType) {
                    case 1: return formatDate(report.reportEndDate, format);
                    case 2: return `${formatDate(report.reportStartDate, format)} - ${formatDate(report.reportEndDate, format)}`;
                    case 3: return report.reportYear ? `31/12/${report.reportYear}` : '';
                }
            },
            unselectOtherRow(row, selected) {
                if (selected) {
                    this.availableReports.forEach((item) => {
                        if (item.id != row.id && item.reportedUnitId == row.reportedUnitId && item.rowSelected) {
                            item.rowSelected = false;
                        }
                    });
                }
            },
            toggleSelectAll(selected) {
                if (!selected) {
                    this.availableReports.forEach((item) => {
                        if (item.rowSelected) {
                            item.rowSelected = false;
                        }
                    });
                } else {
                    this.allGroupReports.forEach((group) => {
                        if (group.length == 1) {
                            if (!group[0].rowSelected) {
                                group[0].rowSelected = true;
                            }
                        } else {
                            if (group.filter(x => x.rowSelected).length == 0) {
                                group[0].rowSelected = true;
                            }
                        }
                    });
                }
            },
            filterGrid(row, filter) {
                if (filter) {
                    try {
                        return row.reportedUnitName.localeContain(filter) || formatDate(row.syncDate, 'DD/MM/YYYY HH:mm:ss').localeContain(filter) || this.getReportDate(row).localeContain(filter);
                    } catch (ex) {
                        console.log(ex);
                        return false;
                    }
                } else {
                    return true;
                }
            },
            hideModalAndReset() {
                var vm = this;
                vm.reportRequest.NGAY_BAO_CAO = null;
                vm.reportRequest.TU_NGAY = null;
                vm.reportRequest.DEN_NGAY = null;
                vm.reportRequest.NAM = null;
                vm.reportRequest.syncDataSourceId = vm.listSyncDataSources[0].value || null;
                vm.$v.reportRequest.$reset();
                vm.$bvModal.hide('reportRequestModal');
            },
            loadReportRequestParameterByReportTypeId(reportTypeId) {
                let vm = this;
                if (reportTypeId) {
                    vm.$services.get(`lookup/report-request-parameters/${reportTypeId}/list`).done((response) => {
                        if (response.length != 0) {
                            vm.isShowBtnReportRequest = true;
                            vm.reportRequestIsConfig = response[0];
                            let syncDataSourceIds = [...new Set(response.map(x => x.syncDataSourceId.toString()))];
                            vm.listSyncDataSources = [...vm.listSyncDataSourceFulls.filter(x => syncDataSourceIds.indexOf(x.id) != -1)];
                            if (vm.listSyncDataSources) {
                                vm.reportRequest.syncDataSourceId = vm.listSyncDataSources[0].value || null;
                            }
                        }
                        else {
                            vm.isShowBtnReportRequest = false;
                        }
                    });
                }
            }
        }
    }
</script>
<style scoped>
    iframe {
        border: none;
        width: 100%;
        height: 540px;
    }

    .report-group {
        font-weight: bold;
    }

    .custom-table-striped tbody:nth-of-type(odd) {
        background-color: rgba(0, 0, 21, 0.05);
    }
</style>
